<template>
  <div class='EnbItem02'
  v-if="exibeSemEstoque"
  @click="Select"
  :style="{
    backgroundColor: Prefes.produto.corBackground,
    fontFamily: Prefes.produto.font,
    color: Prefes.produto.corFont,
    fontStyle: parseInt(Prefes.produto.fontStyle) ? 'italic' : '',
    fontWeight: parseInt(Prefes.produto.fontBold) ? 'bold' : '',
    textDecoration: parseInt(Prefes.produto.textDecoration) ? 'underline' : '',
    fontSize: Prefes.produto.fontHeight + 'px'
  }"
  >
    <div class="cont-img">
      <div class="btn-action" v-if="Object.keys(Profile).length && Profile.tipo === 'a'" @click.stop>
        <edit-icon @click="edit"/>
        <edit-fast-icon @click="fastEdit"/>
        <delete-icon @click="del"/>
      </div>
      <enb-itemImg02 :data="data"/>
    </div>
    <div class="cont-desc">
      {{ data.name }}
    </div>
    <div class="cont-descricao" v-if="data.descricao">
      {{ data.descricao }}
    </div>
    <div class="cont-valor">
      <span class="preco-antigo" v-if="isString(data.oferta) > 0">{{ toBRL(data.preco) }}</span>
      <!-- cor da fonte do "Botão produto" nas preferências; sem ela, fica o verde padrão -->
      <span class="preco" :style="{ color: Prefes.btnProduto && Prefes.btnProduto.corFont }">{{ toBRL(valorFinal) }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EnbItemImg02 from './EnbItemImg02'
import EditFastIcon from '@/components/EnbPainel/Icons/EditFastIcon'
import EditIcon from '@/components/EnbPainel/Icons/EditIcon'
import DeleteIcon from '@/components/EnbPainel/Icons/DeleteIcon'
export default {
  name: 'EnbItem02',
  components: { EnbItemImg02, EditFastIcon, EditIcon, DeleteIcon },
  computed: {
    ...mapGetters(['Profile', 'SelectedProds', 'Prefes']),
    exibeSemEstoque () {
      if(this.data.gerEstoque && this.data.tipo !== 'Variável') {
        if(this.data.exibeSemEstoque) {
          return true
        }
        else {
          return this.data.estoque > 0
        }
      }
      else {
        return true
      }
    },
    valorFinal () {
      return this.isString(this.data.oferta) > 0 ? this.isString(this.data.oferta) : this.isString(this.data.preco)
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    ...mapActions(['PushProdEdit', 'ClearProdEdit', 'SetModal01', 'DeleteProd', 'SetModal', 'SetItem01']),
    Select () {
      this.SetItem01(this.data)
        .then(() => {
          if(typeof this.$route.params.categ !== 'undefined') {
            this.$router.push(`/loja/${this.$route.params.categ}/${this.data.link}`)
          } else {
            this.$router.push(`/${this.data.link}`)
          }
        })
    },
    edit () {
      this.ClearProdEdit()
        .then(() => this.PushProdEdit(this.data))
        .then(() => {
          this.$router.push('/painel/produtos/edit')
        })
    },
    fastEdit () {
      this.ClearProdEdit()
        .then(() => this.PushProdEdit(this.data))
        .then(() => {
          this.SetModal01({ component: 'FastProdEdit', active: true })
        })
    },
    del () {
      this.SetModal({
        component: 'AskAction',
        active: true,
        ask: 'Tem certeza que deseja excluir o produto?',
        action: 'DeleteProd',
        payload: [this.data]
      })
    },
    isString (value) {
      return typeof value === 'string' ? parseFloat(value.replace(/\./g, '').replace('R$ ', '').replace(',', '.')) : value
    },
    toBRL (value) {
      return (this.isString(value) || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
    }
  }
}
</script>

<style scoped>
/* sem altura fixa: estica até o card mais alto da linha do grid, e o preço (margin-top: auto) fica alinhado */
.EnbItem02 {
  width: 23%;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  padding: 15px;
  box-sizing: border-box;
  border-radius: 5px;
  margin: 1%;
  text-align: left;
  cursor: pointer;
  transition: box-shadow 0.2s;
}

.EnbItem02:hover {
  box-shadow: 0px 0px 8px 1px #00000055;
}

/* margens negativas anulam o padding do card: a imagem vai até as bordas de cima e dos lados */
.cont-img {
  width: calc(100% + 30px);
  margin: -15px -15px 0;
  height: 200px;
  position: relative;
  border-radius: 5px 5px 0 0;
  overflow: hidden;
}

.cont-desc {
  width: 100%;
  padding-top: 15px;
  font-size: 1.05em;
  line-height: 1.3;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

.cont-descricao {
  white-space: pre-line;
  width: 100%;
  padding-top: 8px;
  font-size: 0.85em;
  line-height: 1.3;
  text-align: center;
  opacity: 0.6;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

.cont-valor {
  margin-top: auto;
  padding-top: 15px;
}

span {
  display: block;
}

.preco-antigo {
  font-size: 0.75em;
  color: #999999;
  text-decoration: line-through;
}

.preco {
  font-size: 1.6em;
  font-weight: bold;
  color: #2E9B3A;
  padding-top: 2px;
}

.btn-action {
  display: flex;
  position: absolute;
  background-color: #FFFFFF;
  z-index: 2;
}

@media (max-width: 500px) {
  .EnbItem02 {
    width: 48%;
    padding: 10px;
  }
  .cont-img {
    width: calc(100% + 20px);
    margin: -10px -10px 0;
    height: 150px;
  }
}
</style>
